const ITEMS = [
  "DISCOVER → DEFINE → VALIDATE → DELIVER → MEASURE",
  "UNDERSTAND BEFORE YOU INVEST",
  "PROTOTYPE BEFORE YOU BUILD",
  "BETWEEN THE BUSINESS PROBLEM AND THE TECHNOLOGY",
  "MEASURABLE OUTCOMES, NOT ASSUMPTIONS",
  "THE RIGHT SOLUTION DEPENDS ON THE CAUSE",
];

export default function EditorialMarquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="marquee-paused overflow-hidden border-b border-line bg-canvas-muted/60 py-4"
    >
      <div className="animate-marquee flex w-max">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-10 whitespace-nowrap pr-10 font-mono text-[11px] tracking-[0.3em] text-slate-500"
          >
            {item}
            <span className="block h-1.5 w-1.5 bg-slate-300" />
          </span>
        ))}
      </div>
    </div>
  );
}
